import api from '../utils/axios';

export const createUser = async (userData) => {
  try {
    const response = await api.post('/admin/create', userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getAdminUsers = async () => {
  try {
    const response = await api.get('/admin/admins');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateAdmin = async (id, userData) => {
  try {
    const response = await api.put(`/admin/admin/${id}`, userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const deleteAdmin = async (id) => {
  try {
    const response = await api.delete(`/admin/admin/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const toggleAdminStatus = async (id) => {
  try {
    const response = await api.patch(`/admin/admin/${id}/toggle-status`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
}; 